import api from "@/config/api";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type {
  FiscalExportParams,
  FiscalExportResult,
} from "../types/fiscal-export.types";

const EXPORT_TIMEOUT_MS = 60_000;

const FILENAME_PATTERN = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i;

function parseFilename(contentDisposition: unknown): string | null {
  if (typeof contentDisposition !== "string") return null;
  const match = FILENAME_PATTERN.exec(contentDisposition);
  if (!match?.[1]) return null;
  try {
    return decodeURIComponent(match[1].trim());
  } catch {
    return match[1].trim();
  }
}

function parseCount(value: unknown): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

export const fiscalExportService = {
  downloadPeriodZip: async (
    params: FiscalExportParams,
  ): Promise<FiscalExportResult> => {
    const response = await api.get<Blob>(
      API_ENDPOINTS.FISCAL_EXPORT_ADMIN.PERIOD_ZIP,
      {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          types: params.types,
        },
        responseType: "blob",
        timeout: EXPORT_TIMEOUT_MS,
      },
    );

    const headers = response.headers as Record<string, unknown>;

    return {
      blob: response.data,
      filename:
        parseFilename(headers["content-disposition"]) ??
        `notas-fiscais_${params.startDate}_a_${params.endDate}.zip`,
      nfseCount: parseCount(headers["x-export-nfse-count"]),
      nfceCount: parseCount(headers["x-export-nfce-count"]),
      skippedCount: parseCount(headers["x-export-skipped-count"]),
    };
  },
};
